<template>
  <div class="container-fluid">
    <communication-form
      :loading="loading"
      :contact="contact"
      :property="property"
      :communicationData="communication"
      :isCollection="isCollection"
      :formErrors="formErrors"
      @communicationSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import { Select, Option } from "element-ui";
import defaultTaxes from "@/constants/defaultTaxes";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultCommunication from "../defaultCommunication";
import CommunicationForm from "../partials/CommunicationForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    CommunicationForm,
  },

  mixins: [alertLeave],
  props: ["property", "contact", "isCollection"],

  data() {
    const communication = cloneDeep(defaultCommunication);
    const me = this.$store.getters["profile/me"];
    return {
      communication: communication,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(communication) {
      this.loading = true;

      const communicationData = cloneDeep(communication);
      delete communicationData.id;

      try {
        if(this.isCollection) {
          communicationData.propertiesCollections = communicationData.properties;
          communicationData.isCollection = true;
          delete communicationData.properties;
        }
        await this.$store.dispatch("communications/add", communicationData);
        this.$notify({
          type: "success",
          message: this.$t("COMMUNICATIONS.COMMUNICATION_ADDED"),
        });
        const communication = this.$store.getters["communications/communication"];
        if(this.property || this.contact){
          this.$emit("communicationCreated");
        }else{
          this.$emit("onViewCommunication", communication, true);
        }
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
